<template>
  <div
    class="switch"
    :class="{ 'active': value }"
    @click.stop="$emit('change')"
  >
    <div>
      <fps-loading v-show="loading" :size="24" color="#FED838" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    }
  }
}
</script>

<style lang="scss" scoped>
  .switch {
    flex-shrink: 0;
    position: relative;
    width: 88px;
    height: 52px;
    border-radius: 60px;
    background: $color-gray-3;
    padding: 10px 12px;
    &::before {
      content: '';
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 52px;
      border-radius: 60px;
      background: $color-yellow;
      opacity: 0;
      transition: opacity 0.3s;
    }
    &::after {
      content: '';
      position: absolute;
      width: 120px;
      height: 88px;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
    }
    > div {
      position: relative;
      z-index: 1;
      display: block;
      width: 32px;
      height: 32px;
      padding: 4px;
      border-radius: 32px;
      background: #fff;
      transition: transform 0.3s;
    }
    &.active {
      &::before {
        opacity: 1;
      }
      > div {
        transform: translateX(100%);
      }
    }
  }
</style>
